import { useMemo } from 'react';
import { useCountries } from './useCountries';
import { useFlag } from './useFlag';

export const useBattery = () => {
  const danish = useFlag('battery-pickup-dk');
  const finnish = useFlag('battery-pickup-fi');

  const { supportedCountries } = useCountries();

  const batterySupportedCountries = useMemo(() => {
    return {
      sweden: supportedCountries.sweden,
      denmark: supportedCountries.denmark && danish,
      finland: supportedCountries.finland && finnish,
      norway: supportedCountries.norway,
    };
  }, [supportedCountries, danish, finnish]);

  const batteryEnabled = useMemo(() => {
    if (supportedCountries.sweden) {
      return true;
    }

    if (supportedCountries.denmark && danish) {
      return true;
    }

    if (supportedCountries.finland && finnish) {
      return true;
    }

    if (supportedCountries.norway) {
      return true;
    }

    return false;
  }, [supportedCountries, danish, finnish]);

  return {
    batteryEnabled,
    batterySupportedCountries,
  };
};
